export function summarizeRanges(ranges) {
  let result = 0;
  ranges.forEach((range) => {
    result += range.end - range.start;
  });
  return result;
}
